import type { ReactNode } from 'react';
import { Icon, type IconName } from '../Icon/Icon';
import styles from './Card.module.scss';

interface CardProps {
    title: string;
    icon: IconName;
    action?: ReactNode;
    children: ReactNode;
}

/** Карточка правой колонки: бровка с иконкой сверху, контент снизу. */
export function Card({ title, icon, action, children }: CardProps) {
    return (
        <section className={styles.card}>
            <header className={styles.head}>
                <Icon name={icon} size={14} />
                <b>{title}</b>
                {action && <span className={styles.action}>{action}</span>}
            </header>
            <div className={styles.body}>{children}</div>
        </section>
    );
}